import { Field, useField } from 'formik';
import React from 'react';
import '../Form.scss';

const RadioInput = ({ label, options, ...props }) => {
    const [field, meta, helpers] = useField(props);

    let classes = 'form-input-value'

    let requiredLabel = undefined
    let error = undefined

    if (props.isrequired === 'true') {
        requiredLabel = '*'
    }

    if (meta.error) {
        error = <div className='invalid-radio'>{meta.error}</div>
    }

    return (
        <div id={props.id} className='form-input'>
            {label && <label htmlFor={props.name} className='form-input-label'>
                {label}{requiredLabel}
            </label>
            }
            <div className={classes} role='group' aria-labelledby={props.name + '-group'}>
                {
                    options.map((option, index) => {
                        return (
                            <>
                                <Field type='radio' name={props.name} title={option.title || option.label} value={option.value} />
                                <label for={`${props.id}-${index}`}>
                                    {option.label}
                                </label>
                            </>
                        )
                    })
                }
                {error}
            </div>
        </div>
    );
};

export default RadioInput